import React from 'react';
import './index.css'
import { useSelector } from 'react-redux';

function ConsultationDetails() {
    let reduxData = useSelector(state => state);
    let appoinmentHistory = reduxData?.interBranchCoordinator?.interBranchPatientDetails?.data?.appointmentHistory;
    console.log("Patient Consultation History - ",appoinmentHistory)
    return (

        <div className='consultation-container'>
            <span className="header">Appointment ID - {appoinmentHistory?.[0].prescriptionId}</span>

            <div className="consultation-appointment-timeline">
                <div className="step">
                    <div className="step-graph">

                        <div className="round">&nbsp;</div>
                        <div className="length">&nbsp;</div>

                    </div>

                    <div className="step-text">

                        <div className="date">{appoinmentHistory?.[0].appointmentDate}</div>

                        <div className="row">For - <div className="date">{appoinmentHistory?.[0].doctorName}</div></div>

                        <div className="row">No further input from your provider</div>

                        <div className="step-end">&nbsp;</div>

                    </div>
                </div>

                <div className="step">
                    <div className="step-graph">

                        <div className="round yellow">&nbsp;</div>
                        <div className="length">&nbsp;</div>

                    </div>

                    <div className="step-text">

                        <div className="date">{appoinmentHistory?.[0].appointmentDate}</div>

                        <div className="row">Patient Name - <div className="date">{appoinmentHistory?.[0].consultantName}</div></div>

                        {/* <div className="row">Reports from patient</div>

                        <ul>
                            <li>Report 1</li>
                            <li>Report 2</li>
                        </ul>

                        <div className="row">Other documents</div>

                        <ul>
                            <li>Patient Consent Form</li>
                            <li>Consultation Invoice</li>
                        </ul> */}


                        <div className="consultation-end">End of Consultation</div>

                    </div>
                </div>


            </div>
        </div>

    );
}

export default ConsultationDetails;
